"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLogo = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledLogo = _styledComponents.default.button.withConfig({
  displayName: "Logostyles__StyledLogo",
  componentId: "sc-16lxixi-0"
})(["border:none;cursor:pointer;line-height:0;margin:0;padding:0;-ms-interpolation-mode:bicubic;&:focus{outline:none;}.c-logo-img{display:block;width:138px;}.c-logo-img-mobile{width:120px;}"]);

exports.StyledLogo = StyledLogo;